import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchVisionEquipments({ visionParams }) {
  try {
    const { data } = yield call(api.get, {
      route: `SocialDV/GetSociaDVByFactoryId/` + visionParams.factoryId,
    });
    const visionEquipments = data;
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setVisionEquipments({ visionEquipments }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_VISION_EQUIPMENTS, fetchVisionEquipments),
  ]);
}
